import { render } from "./GatewaySettings.vue?vue&type=template&id=53c056be&scoped=true&ts=true"
import script from "./GatewaySettings.vue?vue&type=script&lang=ts"
export * from "./GatewaySettings.vue?vue&type=script&lang=ts"

import "./GatewaySettings.vue?vue&type=style&index=0&id=53c056be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c056be"]])

export default __exports__